import React from 'react';

import { Text } from '@auspost/postmaster-react';

import HappyIcon from 'assets/happy.svg';
import HelpIcon from 'assets/help.svg';
import LocationIcon from 'assets/location.svg';
import NotificationIcon from 'assets/notification.svg';
import NotificationSettingsIcon from 'assets/notification-settings.svg';
import ParcelIcon from 'assets/parcel.svg';
import ProfileSettingsIcon from 'assets/profile-settings.svg';
import RedirectIcon from 'assets/redirect-street-address.svg';
import TrashIcon from 'assets/trash.svg';

import styles from './RowContent.module.scss';

export const ROW_CARD_ICONS = {
  location: <LocationIcon className={styles.icon} />,
  help: <HelpIcon className={styles.icon} />,
  parcel: <ParcelIcon className={styles.icon} />,
  redirect: <RedirectIcon className={styles.icon} />,
  profileSettings: <ProfileSettingsIcon className={styles.icon} />,
  notification: <NotificationIcon className={styles.icon} />,
  notificationSettings: <NotificationSettingsIcon className={styles.icon} />,
  happy: <HappyIcon className={styles.icon} />,
  trash: <TrashIcon className={styles.icon} />,
} as const;

export interface RowContentProps {
  icon: React.ReactElement<React.SVGProps<SVGSVGElement>>;
  text: string;
}

const RowContent: React.FC<RowContentProps> = ({ icon, text }) => (
  <>
    {icon}
    <Text variant='body-small' weight='medium' className={styles.text}>
      {text}
    </Text>
  </>
);

export default RowContent;
